export default __webpack_public_path__ + "static/media/icon-cast.e8f9ed28.svg";